import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ScreenPopupState {
  isOpen: boolean;
  screenId?: string;
  title?: string;
}

const initialState: ScreenPopupState = {
  isOpen: false,
  screenId: undefined,
  title: undefined,
};

const screenPopupSlice = createSlice({
  name: "screenPopup",
  initialState,
  reducers: {
    openScreenPopup(
      state,
      action: PayloadAction<{ screenId: string; title?: string }>
    ) {
      state.isOpen = true;
      state.screenId = action.payload.screenId;
      state.title = action.payload.title;
    },
    closeScreenPopup(state) {
      state.isOpen = false;
      state.screenId = undefined;
      state.title = undefined;
    },
  },
});

export const { openScreenPopup, closeScreenPopup } = screenPopupSlice.actions;
export default screenPopupSlice.reducer;

